import { render, staticRenderFns } from "./standardCourseCardTwo.vue?vue&type=template&id=2da989aa&"
import script from "./standardCourseCardTwo.vue?vue&type=script&lang=js&"
export * from "./standardCourseCardTwo.vue?vue&type=script&lang=js&"
import style0 from "./standardCourseCardTwo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports